import { render, staticRenderFns } from "./shopDebt.vue?vue&type=template&id=1ffd6214&scoped=true"
import script from "./shopDebt.vue?vue&type=script&lang=js"
export * from "./shopDebt.vue?vue&type=script&lang=js"
import style0 from "./shopDebt.vue?vue&type=style&index=0&id=1ffd6214&prod&lang=css"
import style1 from "./shopDebt.vue?vue&type=style&index=1&id=1ffd6214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd6214",
  null
  
)

export default component.exports